// store/modules/randomChat.js
const state = {
    fake: [],
};

const mutations = {
    fake(state, fake) {
        state.fake = fake;
    },
};

// miserable but meh
const actions = {
    // fake event to listen for in component
    handleCompatibleUsers({ commit }, data) {
        commit("fake", data);
    },
    handleMatch({ commit }, data) {
        commit("fake", data);
    },
    handleVacate({ commit }, data) {
        commit("fake", data);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
